"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardActions.default;
  }
});

var _CardActions = _interopRequireDefault(require("./CardActions"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/CardActions/index.js
 ** module id = 815
 ** module chunks = 0
 **/